
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Vector } from "../../../domain/drawing";
import { AsyncRequestPool } from "../../../utilities";
import { MouseTrackableMixin } from ".";

@Component({
})
export default class LinearLayoutableMixin extends Mixins(MouseTrackableMixin) {
  data(): any {
    return {
      linearLayouterRequestPool: new AsyncRequestPool<Vector, { result: Vector }>(),
    };
  }
  linearLayouterRequestPool: AsyncRequestPool<Vector, { result: Vector }>;

  get isLinearLayouting(): boolean {
    return this.linearLayouterRequestPool.isProcessing
      && !!this.linearLayouterRequestPool.processingRequest.source.result
      && !this.linearLayouterRequestPool.processingRequest.source.result.to;
  }

  get layouterLinear(): Vector {
    return this.isLinearLayouterVisible
      ? new Vector(this.linearLayouterRequestPool.processingRequest.source.result.from, this.mouseLocation)
      : new Vector();
  }

  get isLinearLayouterVisible(): boolean {
    return this.isLinearLayouting
      && !!this.linearLayouterRequestPool.processingRequest.source.result.from;
  }

  @Watch("isMouseLeftButtonPressed")
  onMouseLeftButtonClickedForLinearLayouter(newValue: boolean, oldValue: boolean) {
    if (!this.linearLayouterRequestPool.isProcessing || !this.linearLayouterRequestPool.processingRequest.source.result) {
      return;
    }
    if (newValue) {
      this.linearLayouterRequestPool.processingRequest.source.result = new Vector(this.mouseLocation, null);
    } else if (this.linearLayouterRequestPool.processingRequest.source.result.from) {
      this.linearLayouterRequestPool.processingRequest.source.result = new Vector(this.linearLayouterRequestPool.processingRequest.source.result.from, this.mouseLocation);
    }
  }

  async layoutLinear(): Promise<Vector> {
    return this.linearLayouterRequestPool.request(
      {
        result: new Vector(null, null),
      },
      this,
      async (source: { result: Vector }) => {
        await this.$wait(() => !this.isLinearLayouting);
        return (!source.result || !source.result.from || !source.result.to)
          ? null
          : source.result;
      },
    );
  }

  cancelLinearLayouting(): void {
    this.linearLayouterRequestPool.cancel(this);
  }
}
